module.exports = "<div class=\"empty-chat\">\n    <div class=\"user-name\">\n        Chào mừng {{user.name}}\n    </div>\n    <p class=\"title\">Truy cập nhanh để thiết lập trợ lý chăm sóc khách hàng của bạn</p>\n    <ul class=\"navigation\">\n        <li *ngFor=\"let route of routers\">\n            <a [routerLink]=\"route.url\">{{route.name}}</a>\n        </li>\n    </ul>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/admin/icontact/chat/empty-chat/empty-chat.component.html
// module id = ./src/app/pages/admin/icontact/chat/empty-chat/empty-chat.component.html
// module chunks = main